// extracted by mini-css-extract-plugin
module.exports = {"saleList":"SaleList_saleList__3CXgE","setContainer":"SaleList_setContainer__2bmgE"};